'use strict';

Object.defineProperty(exports, '__esModule', {
	value: true
});
function LineListController($state, $filter, LineComponent, PageHeading) {
	'ngInject';

	var vm = this;

	vm.getLines = LineComponent.getLines;
	vm.paginationInfo = LineComponent.getPaginationInfo();
	vm.loadPage = LineComponent.fetchLines;
	vm.routeName = 'app.private.seats.edit';

	activate();

	function activate() {
		var heading = $filter('translate')('SIDEBAR.SEATS');
		var title = 'BTMS | ' + $filter('translate')('SIDEBAR.SEATS');

		PageHeading.setPageHeading(heading, title);
	}
}

exports['default'] = LineListController;
module.exports = exports['default'];


/** WEBPACK FOOTER **
 ** ./client/private/seats/choose-line/choose-line.controller.js
 **/